export default __webpack_public_path__ + "897c2f02348dfdb1f555931886fea416.svg";